// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "face_group_asset".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { faceGroupAssetRoleValues } from '@borradh-workspace/labels';
/** Response atom for the "face_group_asset" table (1:1 with a DB row, on the wire). */
export const faceGroupAssetAtomSchema = z.object({
    id: z.string(),
    faceGroupId: z.string(),
    assetId: z.string(),
    batchId: z.string().nullable(),
    role: z.enum(faceGroupAssetRoleValues),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=faceGroupAsset.js.map